// extracted by mini-css-extract-plugin
export default {"faq":"FAQPage_faq__xyR38","content":"FAQPage_content__kDloq","dash":"FAQPage_dash__cOn5F"};